import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';

import ViewerSkeleton from '@/components/viewerSkeleton';

import { AppThemeProvider } from './theme/appThemeProvider';

const StoreProvider = lazy(() => import('./storeProvider'));

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
    <AppThemeProvider>
        <CssBaseline />
        <Suspense fallback={<ViewerSkeleton />}>
            <StoreProvider />
        </Suspense>
    </AppThemeProvider>
);
